{
  "sidebar": {
    "data": {
      "title": "Dado"
    },
    "insights": {
      "title": "Insights"
    },
    "instances_caches": {
      "title": "Caches"
    },
    "jvm": {
      "title": "JVM"
    },
    "logging": {
      "title": "Logging"
    },
    "security": {
      "title": "Segurança"
    },
    "web": {
      "title": "Web"
    }
  }
}
